/** English — source of truth; missing keys in other locales fall back here. */
const en = {
  'myDay.heading': 'My day',
  'myDay.welcome': 'Check in, take one step, keep your team in the loop.',
  'myDay.title': 'Let’s move work forward',
  'myDay.hint': 'Due work first, then what’s already in motion.',
  'myDay.next': 'Next to review',
  'myDay.completed': '{n} completed today',
  'myDay.open': '{n} open on your board',
  'myDay.progressHint': 'Completions use today’s IST date. Open work is your whole backlog, not a daily target.',
  'myDay.emptyHint': 'A little breathing room. Add a task when you’re ready.',
  'myDay.loadError': 'We couldn’t load your tasks. Your attendance is unaffected.',
  'myDay.start': 'Start task',
  'myDay.update': 'Quick update',
  'myDay.finish': 'Mark done',
  'myDay.help': 'Waiting / need help',
  'myDay.showAll': 'See all {n} open tasks',
  'myDay.showLess': 'Show fewer tasks',
  'myDay.add': 'What else needs doing?',
  'myDay.reviewTitle': 'You’re punched out. A quick wrap-up?',
  'myDay.reviewHint': 'Select only finished tasks. Everything else stays open with its current status and due date, ready for your next day.',
  'myDay.planHint': 'Select tasks to start, or continue what’s in progress. Unchecked work stays unchanged — nothing is marked done.',
  'myDay.later': 'I’ll do this later',
  'myDay.carryForward': 'Keep all remaining work open',
  'myDay.completeSelected': 'Complete selected ({n})',
  'board.seen': 'Seen {date}',
  'board.delivered': 'Delivered',
  'board.due.label': 'Due',
  'board.due.optional': 'Due date (optional)',
  'board.due.overdue': 'Overdue',
  'board.due.today': 'Due today',
  'board.date.today': 'Today',
  'board.date.tomorrow': 'Tomorrow',
  'board.date.friday': 'This Fri',
  'board.date.monday': 'Next Mon',
  'board.updates.title': 'Card update',
  'board.return.context': 'Helping another task',
  'board.return.helping': 'This task is helping {owner}: {title}',
  'board.return.action': 'My part is done — return to requester',
  'board.return.guidance': 'This removes the helper from your board, including Done, and keeps its history. Your message goes to the requester’s original task. Their task resumes in Doing after all helpers finish and no external wait remains.',
  'board.return.messageRequired': 'Write a required handback message in “What has changed?” below before returning.',
  'board.return.confirm': 'Remove this helper from your board and send your message back to {owner}: {title}? Its history is kept. The requester’s original task will not be marked done.',
  'board.return.blockers': 'Unresolved dependencies',
  'board.return.resolveFirst': 'Resolve these dependencies before completing, returning, or deleting this task.',
  'board.return.parentSelected': 'This person requested your help. Do not create a helper task back to them. If your part is finished, use “My part is done — return to requester”.',
  'board.updates.prompt': 'What has changed?',
  'board.updates.waitingOn': 'Waiting on (optional)',
  'board.updates.nextFollowup': 'Next follow-up (optional)',
  'board.updates.timeline': 'Update timeline',
  'board.updates.add': 'Add update',
  'board.updates.empty': 'No updates yet.',
  'board.updates.unavailable': 'This card is unavailable or you no longer have access.',
  'board.updates.status': 'Status',
  'board.status.on_track': 'On track',
  'board.status.waiting': 'Waiting',
  'board.status.blocked': 'Blocked',
  'board.status.done': 'Done',
  'board.reminders.title': 'From Omar',
  'board.reminders.nudged': 'An update has been requested.',
  'board.reminders.empty': 'Nothing needs a check-in right now.',
  'board.reminders.dismiss': 'Dismiss for today',
  'board.quick.start': 'Still working',
  'board.quick.done': 'Done',
  'board.quick.text.on_track': 'Still working on this.',
  'board.quick.text.waiting': 'Waiting for a response.',
  'board.quick.text.blocked': 'Blocked: ',
  'board.quick.text.done': 'Completed this task.',
  'board.create.step': 'Step {n} of 3',
  'board.create.guidance': 'Name one clear task you can finish.',
  'board.create.back': 'Back',
  'board.create.next': 'Next',
  'board.create.keepStatus': 'Keep selected column',
  'common.loading': 'Loading...',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.submit': 'Submit',
  'common.submitting': 'Submitting...',
  'common.retry': 'Retry',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.close': 'Close',
  'common.location': 'Location',

  'a11y.rowActions': 'Row actions',

  'pagination.total': '{count} total',
  'pagination.pageOf': 'page {page} of {total}',
  'pagination.previous': 'Previous',
  'pagination.next': 'Next',

  'unit.hours': 'h',
  'unit.days': 'd',

  'lang.label': 'Language',
  'lang.english': 'English',
  'lang.kannada': 'ಕನ್ನಡ',
  'lang.odia': 'ଓଡ଼ିଆ',
  'lang.hindi': 'हिन्दी',

  'login.brand.eyebrow': 'Time & attendance',
  'login.brand.title': 'Punch in,\nstay on track.',
  'login.brand.subtitle': 'Track hours, tasks, and leave from one place.',
  'login.brand.footer': 'Staff access only.',
  'login.signIn': 'Sign in',
  'login.signInHint': 'Enter your work email and password.',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.passwordPlaceholder': 'Enter password',
  'login.signingIn': 'Signing in...',
  'login.emailPasswordRequired': 'Email and password are required',
  'login.togglePassword': 'Toggle password visibility',
  'login.mfa.title': 'Two-step verification',
  'login.mfa.hint': 'Enter the 6-digit code from your authenticator app.',
  'login.mfa.code': 'Verification code',
  'login.mfa.verify': 'Verify',
  'login.mfa.verifying': 'Verifying...',
  'login.mfa.codeRequired': 'Enter the 6-digit code from your authenticator app',
  'login.setup.title': 'Set up two-step verification',
  'login.setup.hint':
    'Two-step verification is required for HR and admin accounts. It takes about a minute.',
  'login.setup.scanHint':
    'Scan this QR code with an authenticator app such as Google Authenticator, Microsoft Authenticator, or 1Password.',
  'login.setup.qrAlt': 'Authenticator QR code',
  'login.setup.manualSummary': "Can't scan? Enter the key manually",
  'login.setup.manualHint': 'Enter this key in your authenticator app:',
  'login.setup.codeLabel': 'Enter the 6-digit code from the app',
  'login.setup.enabling': 'Enabling...',
  'login.setup.enable': 'Turn on two-step verification',
  'login.setup.codeRequired': 'Enter the 6-digit code shown in your authenticator app',

  'app.loading': 'Loading...',

  'footer.text': 'Teams · build {version}',

  'nav.self': 'Self',
  'nav.today': 'Today',
  'nav.myRequests': 'My requests',
  'nav.board': 'Board',
  'nav.teamBoard': 'Team board',
  'nav.history': 'History',
  'nav.holidays': 'Holidays',
  'nav.handbook': 'Handbook',
  'nav.announcements': 'Announcements',

  'meta.today.title': 'Today',
  'meta.today.subtitle': 'Punch in and out, and what your day looks like',
  'meta.today.exemptSubtitle': 'Your tasks, leave, and updates for today',
  'meta.board.title': 'Board',
  'meta.board.subtitle': 'Your personal to-do board — drag cards between columns',
  'meta.teamBoard.title': 'Team board',
  'meta.teamBoard.subtitle': "Everyone's cards — move, edit, and delete",
  'meta.my_requests.title': 'My requests',
  'meta.my_requests.subtitle': 'Leave, late and early-leaving you have filed',
  'meta.history.title': 'History',
  'meta.history.subtitle': 'Your punch history',
  'meta.handbook.title': 'Handbook',
  'meta.handbook.subtitle': 'Announcements, rules, HR policy and holidays',

  'role.employee': 'Employee',
  'role.hr': 'HR',
  'role.admin': 'Admin',
  'shell.logout': 'Log out',
  'shell.openNav': 'Open navigation',
  'shell.closeNav': 'Close navigation',
  'shell.themeLight': 'Switch to light theme',
  'shell.themeDark': 'Switch to dark theme',
  'shell.primaryNav': 'Primary navigation',
  'shell.more': 'More',
  'shell.moreHint': 'Your available destinations and account controls.',
  'shell.accountControls': 'Account controls',
  'shell.muteSounds': 'Mute sounds',
  'shell.enableSounds': 'Enable sounds',

  'notify.title': 'Notifications',
  'notify.markAllRead': 'Mark all read',
  'notify.enablePush': 'Enable push notifications',
  'notify.enabling': 'Enabling...',
  'notify.empty': 'No notifications yet.',
  'notify.justNow': 'just now',
  'notify.minutesAgo': '{n}m ago',
  'notify.hoursAgo': '{n}h ago',
  'notify.daysAgo': '{n}d ago',
  'notify.pushEnabled': 'Push notifications enabled.',
  'notify.pushFailed': 'Could not enable push notifications.',

  'dashboard.loading': 'Loading dashboard...',
  'dashboard.error': 'Could not load dashboard.',
  'dashboard.onLeave': 'On leave',
  'dashboard.onClock': 'On the clock',
  'dashboard.offClock': 'Off the clock',
  'dashboard.attendanceExempt': 'Attendance exempt',
  'dashboard.attendanceNotRequired': 'No punch-in required',
  'dashboard.attendanceExemptHint': 'Your account is not part of attendance tracking.',
  'dashboard.onLeaveToday': "You're on approved leave today",
  'dashboard.onLeaveDisabled': 'Punching in is disabled while on leave.',
  'dashboard.inSince': 'In since {time}',
  'dashboard.soFar': 'so far',
  'dashboard.notPunchedIn': 'Not punched in',
  'dashboard.punchInHint': 'Punch in when you start working.',
  'dashboard.punchIn': 'Punch in',
  'dashboard.punchOut': 'Punch out',
  'dashboard.stat.today': 'Today',
  'dashboard.stat.week': 'This week',
  'dashboard.stat.leaveLeft': 'Leave left',
  'dashboard.stat.openCards': 'Open cards',
  'dashboard.myTasks': 'My tasks',
  'dashboard.myTasksHint': 'Open cards on your personal board.',
  'dashboard.viewBoard': 'Open board',
  'dashboard.noOpenTasks': 'No open tasks — your board is clear.',
  'dashboard.leave': 'Leave',
  'dashboard.leaveThrough': 'On leave through {date}',
  'dashboard.days': 'day(s)',
  'dashboard.upcomingLeave': 'Upcoming leave: {start} – {end}.',
  'dashboard.noLeaveScheduled': 'No approved leave scheduled.',
  'dashboard.pendingRequests': '{n} request(s) pending approval.',
  'dashboard.yourLeave': 'Your leave',
  'dashboard.noLeaveTypes': 'No leave types configured yet.',
  'dashboard.announcements': 'Announcements',
  'dashboard.noAnnouncements': 'No announcements yet.',
  'dashboard.toast.punchedInZone': 'Punched into {zone}.',
  'dashboard.toast.punchedIn': "You're punched in.",
  'dashboard.toast.punchedInLate': "You're late by {minutes} minute(s).",
  'dashboard.toast.punchedOut': "You're punched out.",

  'punch.board.emptyTitle': 'What are you working on today?',
  'punch.board.emptyHint': 'Add a task for today, or log that you have no assigned work.',
  'punch.board.pickWorkTitle': 'What are you working on today?',
  'punch.board.pickWorkHint': 'Build today’s plan below. A checked task is selected; tap it again to remove it.',
  'punch.board.groupOngoing': 'Ongoing',
  'punch.board.groupAvailable': 'Available',
  'punch.board.groupBlocked': 'Blocked — needs attention',
  'punch.board.blockedHint': 'These are shown for awareness. Resolve the blocker on your board before resuming them.',
  'punch.board.todayPlan': 'Today’s plan',
  'punch.board.selectedCount': '{n} selected',
  'punch.board.selected': 'Selected',
  'punch.board.notSelected': 'Not selected',
  'punch.board.continueToday': 'Continue today',
  'punch.board.willMarkDone': 'Not in today’s plan — will be marked done',
  'punch.board.startToday': 'Start today',
  'punch.board.staysTodo': 'Stays in To do',
  'punch.board.confirmSelected': 'Start day with {n} task(s)',
  'punch.board.confirmNone': 'Mark ongoing tasks done',
  'punch.board.selectTask': 'Select at least one task',
  'punch.board.blockedOnlyHint': 'Your assigned tasks are blocked. Review what needs attention, then add other work for today or log no available work.',
  'punch.board.doingDoneTitle': 'Are these done?',
  'punch.board.doingDoneHint': 'Select any in-progress tasks you finished.',
  'punch.board.pickTodoTitle': 'What will you work on?',
  'punch.board.pickTodoHint': 'Select tasks to move into doing.',
  'punch.board.skip': 'Skip',
  'punch.board.confirm': 'Confirm',
  'punch.board.toast.markedDone': 'Marked done.',
  'punch.board.toast.started': 'Moved to doing.',
  'punch.board.toast.confirmed': 'Work updated.',

  'punchIn.title': 'Punch in',
  'punchIn.home.title': 'Please punch in from home or the office.',
  'punchIn.home.hint': "If you're at the office it will show as Office. Anywhere else shows as Home.",
  'punchIn.untagged': "Sales punch — you'll show as Sales on the roster. GPS location is required and captured; no site geofence applies.",
  'punchIn.gettingLocation': 'Getting your location...',
  'punchIn.atSite': 'At {name}',
  'punchIn.locationCaptured': 'Location captured ({lat}, {lng})',
  'punchIn.refreshLocation': 'Refresh location',
  'punchIn.outsideSiteHint': 'Outside {name} radius: {distance} m away (radius {radius} m). Refresh location, check this site\'s location permission, or ask HR for help.',
  'punchIn.geoUnsupported': 'Geolocation is not supported by this browser.',
  'punchIn.geoDenied':
    'Location access was denied. Please allow location access and try again. If no prompt appears, enable location for this site in your browser settings.',
  'punchIn.geoError': 'Could not determine your location ({msg}).',
  'punchIn.you': 'You',
  'punchIn.kmTo': '— {km} km to {name}',
  'punchIn.placeDetails': 'Place details (optional)',
  'punchIn.lookingUp': 'Looking up this place — you can punch now.',
  'punchIn.placeName': 'Place name (optional)',
  'punchIn.area': 'Area (optional)',
  'punchIn.nameHint': 'Your GPS location is enough. Add or edit the place details if you like, or leave them blank. No hotel or Maps link needed.',
  'punchIn.punchingIn': 'Punching in...',
  'punchIn.fallbackHome': 'Home',
  'punchIn.fallbackField': 'Field',

  'punchOut.title': 'Punch out',
  'punchOut.home.title': 'Please punch out from home or the office.',
  'punchOut.untagged': 'Clock out. GPS location is required and captured for Sales punches.',
  'punchOut.punchingOut': 'Punching out...',

  'requests.new': 'New request',
  'requests.error': 'Could not load requests.',
  'requests.empty': 'No requests yet',
  'requests.edit': 'Edit request',
  'requests.fullRequest': 'Full request',
  'requests.type': 'Type',
  'requests.type.leave': 'Leave',
  'requests.type.late': 'Late',
  'requests.type.early_leaving': 'Early leaving',
  'requests.type.other': 'Other',
  'requests.startDate': 'Start date',
  'requests.endDate': 'End date',
  'requests.halfDay': 'Half day',
  'requests.leaveType': 'Leave type',
  'requests.selectLeaveType': 'Select a leave type...',
  'requests.leaveTypeLabel': '{name} — {remaining} of {quota} left',
  'requests.reasonCategory': 'Reason category',
  'requests.selectCategory': 'Select a category...',
  'requests.reason': 'Reason',
  'requests.date': 'Date(s)',
  'requests.status': 'Status',
  'requests.businessDays': '≈ {n} business day(s).',
  'requests.lateHint': 'Logged for tracking, no approval needed.',
  'requests.error.datesRequired': 'Start and end date are required.',
  'requests.error.leaveTypeRequired': 'Leave type is required.',
  'requests.error.dateRequired': 'Date is required.',
  'requests.error.reasonRequired': 'Reason is required.',
  'requests.toast.updated': 'Request updated.',
  'requests.toast.submitted': 'Request submitted.',
  'requests.toast.deleted': 'Request deleted.',
  'requests.confirmDelete': 'Delete this request?',
  'requests.status.pending': 'pending',
  'requests.status.approved': 'approved',
  'requests.status.rejected': 'rejected',
  'requests.status.logged': 'logged',
  'requests.category.sick': 'sick',
  'requests.category.personal': 'personal',
  'requests.category.vacation': 'vacation',
  'requests.category.family': 'family',
  'requests.category.bereavement': 'bereavement',
  'requests.category.menstrual': 'menstrual',
  'requests.category.other': 'other',

  'board.noWorkToday': 'There is no work for me today',
  'board.loggedToday': 'Logged today',
  'board.loggedTodayTitle': "You've already logged today.",
  'board.error': 'Could not load your board.',
  'board.emptyBoard': 'No cards yet — add one to get started.',
  'board.column.todo': 'To do',
  'board.column.doing': 'Doing',
  'board.column.blocked': 'Blocked',
  'board.column.done': 'Done',
  'board.columnAria': 'Board column',
  'board.addCard': 'Add a card',
  'board.addCardTo': 'Add card to {col}',
  'board.editCard': 'Edit card',
  'board.newCard': 'New card — {col}',
  'board.title': 'Title',
  'board.description': 'Description',
  'board.error.titleRequired': 'Title is required.',
  'board.toast.updated': 'Card updated.',
  'board.toast.created': 'Card created.',
  'board.toast.deleted': 'Card deleted.',
  'board.toast.moved': 'Moved to {col}.',
  'board.toast.logged': 'Logged.',
  'board.confirmDelete': 'Delete "{title}"?',
  'board.moveTo': 'Move to {col}',
  'board.deleteCard': 'Delete card',
  'board.doneAt': 'Done {date}',
  'board.fromLabel': 'From {label}',
  'board.myTask': 'Your task',
  'board.source.commandCentre': 'Command Centre',
  'board.source.chiefOfStaff': 'Omar',
  'board.sharedProgress': 'Shared: {completed}/{total}',
  'board.blockedReason': 'Blocked: {reason}',
  'board.blockedExternal': 'Waiting on {name}',
  'board.helpers': 'Helpers: {helpers}',
  'board.blocking': 'Blocking {user}: {title}',
  'board.toast.blocked': 'Task blocked and helpers notified.',
  'board.block.title': 'Block task',
  'board.block.intro': 'Add helper tasks needed to unblock “{title}”.',
  'board.block.reason': 'What is blocked?',
  'board.block.modeLabel': 'Blocking type',
  'board.block.modeHelpers': 'Hand over to teammate',
  'board.block.modeExternal': 'External party',
  'board.block.externalName': 'External party name',
  'board.block.externalNamePlaceholder': 'e.g. Shafiq sir, vendor name',
  'board.block.externalGuidance': 'Use this only when nobody inside the company can unblock it. Name the person or party and describe what is awaited above.',
  'board.block.missingInfoCta': 'Add blocking info: name a teammate or external party.',
  'board.block.setInfo': 'Set blocking info',
  'board.block.firstNameGuidance': 'Enter the helper’s exact full first name. If more than one person has that name, select the right person below.',
  'board.block.helperNumber': 'Helper {n}',
  'board.block.helperFirstName': 'Helper first name',
  'board.block.helperPerson': 'Helper',
  'board.block.helperPersonPlaceholder': 'Select a teammate',
  'board.block.selectedHelper': 'Selected: {name}',
  'board.block.matches': 'Matching helpers',
  'board.block.helperTask': 'Helper task',
  'board.block.removeHelper': 'Remove helper',
  'board.block.addHelper': 'Add another helper',
  'board.block.submit': 'Block task',

  'teamBoard.readOnly': 'Read-only team view',
  'teamBoard.filterAll': 'Everyone',
  'teamBoard.filterPeople': 'Filter by person',
  'teamBoard.people': 'People',
  'teamBoard.peopleSelected': '{n} people',
  'teamBoard.selectPeople': 'Select people',
  'teamBoard.error': 'Could not load the team board.',
  'teamBoard.emptyColumn': 'No cards',
  'teamBoard.newCardFor': 'New card for {person} — {col}',
  'teamBoard.composerLabel': 'Assign a task',
  'teamBoard.composerPlaceholder': 'Type @ to add people',
  'teamBoard.composerTaskPlaceholder': 'Task for selected people',
  'teamBoard.composerInvalid': 'Choose at least one person and enter a task.',
  'teamBoard.removeRecipient': 'Remove {name}',
  'teamBoard.assign': 'Assign',
  'teamBoard.searchCards': 'Search cards or people',
  'teamBoard.searchPeople': 'Search people',
  'teamBoard.noPeopleMatch': 'No people match.',
  'teamBoard.summary': 'Showing {shown} of {total} cards',
  'teamBoard.emptyBoard': 'No team cards yet.',
  'teamBoard.emptySearch': 'No cards match your search.',
  'teamBoard.clearFilters': 'Clear filters',
  'teamBoard.attention': 'Attention',
  'teamBoard.attentionTitle': 'Needs attention',
  'teamBoard.attentionEmpty': 'Nothing blocked, nothing stale. Every board is moving.',
  'teamBoard.attentionBlocked': 'Blocked ({n})',
  'teamBoard.attentionStale': 'Stuck in Doing 3+ days ({n})',
  'teamBoard.attentionStaleAge': '{age} in Doing',
  'teamBoard.ageDays': '{n}d',
  'teamBoard.usage': 'Usage',
  'teamBoard.usageTitle': 'Board usage',
  'teamBoard.usageName': 'Name',
  'teamBoard.usageLastOpened': 'Last opened',
  'teamBoard.usageOpens': 'Opens',
  'teamBoard.usageNever': 'Never',
  'teamBoard.usageAgo': '{n}d ago',
  'fieldAttention.subtitle': 'Blocked chains and work sitting in Doing across your field team.',
  'fieldAttention.error': 'Could not load the field board.',
  'teamBoard.activity': 'Activity',
  'teamBoard.activityTitle': 'Board activity',
  'teamBoard.activityLoading': 'Loading activity...',
  'teamBoard.activityEmpty': 'No activity yet.',
  'teamBoard.activitySystem': 'System',

  'noWork.title': 'No work today?',
  'noWork.intro':
    'No assigned work today? Log what you picked up instead — a housekeeping item, one of your own cards, or a quick note about who you helped.',
  'noWork.kind.housekeeping': 'Housekeeping',
  'noWork.kind.ownCard': 'One of my cards',
  'noWork.kind.note': 'A quick note',
  'noWork.housekeepingItem': 'Housekeeping item',
  'noWork.noHousekeeping': 'No housekeeping items configured yet — pick another option.',
  'noWork.choose': '— choose —',
  'noWork.yourCard': 'Your card',
  'noWork.noCards': 'No open to-do or blocked cards — pick another option.',
  'noWork.note': 'Note',
  'noWork.notePlaceholder': 'e.g. Helped Ravi with the site survey',
  'noWork.error.pickOne': 'Pick one of the three options below.',
  'noWork.logIt': 'Log it',
  'noWork.recent': 'Recent',
  'noWork.describe.ownCard': 'one of my cards',
  'noWork.describe.housekeeping': 'housekeeping',

  'history.error': 'Could not load work logs.',
  'history.empty': 'No work logs yet',
  'history.date': 'Date',
  'history.in': 'In',
  'history.out': 'Out',
  'history.duration': 'Duration',
  'history.site': 'Site',
  'history.tasks': 'Tasks',
  'history.inProgress': 'In progress',
  'history.remote': 'Remote',

  'holidays.subtitle': 'National and company holidays.',
  'holidays.error': 'Could not load holidays.',
  'holidays.national': 'National holidays',
  'holidays.company': 'Company holidays',
  'holidays.upcoming': 'Upcoming',
  'holidays.empty': 'No holidays listed.',

  'announcements.subtitle': 'Company-wide updates from HR.',
  'announcements.error': 'Could not load announcements.',
  'announcements.empty': 'No announcements yet.',
  'announcements.authorFallback': 'HR',

  'policy.error': 'Could not load this policy.',

  'leave.hint.endBeforeStart': 'End date must be on or after the start date.',
  'leave.hint.startTooPast': 'Start date cannot be more than 7 days in the past.',
  'leave.hint.startTooFuture': 'Start date cannot be more than 1 year in advance.',
  'leave.hint.tooLong': 'Leave requests cannot exceed 30 days.'
} as const;

export default en;
export type MessageKey = keyof typeof en;
